<template>
<div class="box">
	<div class="box__container">
		<div class="box__header">
			<div class="box__header__title">

			</div>
			<div class="box__header__edit" @click="toggleEditProfile">
			<p>{{ 'edit' | translate | capitalize }}</p>
			</div>
		</div>
		<div class="box__body">
			<form @submit.prevent="editProfile" id="editprofile">
				<div class="form__group">
					<label for="name">{{ 'name' | translate | capitalize }}</label>
					<input name="name" type="text"  v-model="user.name" :disabled="!this.toggleEdit">
					<div class="has-error has-message" v-if="errorForm(errors, 'name')">
						<span class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i> {{ 'have-a-error-in-this-field' | translate | capitalize }}</span>
					</div>
				</div>
				<div class="form__group">
					<label>{{ 'party' | translate | capitalize }}</label>
					<select name="party"  v-model="user.party.id" :disabled="!this.toggleEdit">
						<option></option>
						<option v-for="party in partys" :value="party.id" :key="party.id">{{ party.name }}</option>
					</select>
					<div class="has-error has-message" v-show="errorForm(errors, 'party_id')">
						<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i>
							{{ 'have-a-error-in-this-field' | translate | capitalize }}
					</label>
					</div>
				</div>
				<div class="form__group">
					<label>{{ 'office' | translate | capitalize }}</label>
					<select name="office"  v-model="user.office.id" @click='getOffice' :disabled="!this.toggleEdit">
						<option></option>
						<option v-for="office in officer.offices" :value="office.id" :key="office.id">{{office.name}}</option>
					</select>
					<div class="has-error has-message" v-show="errorForm(errors, 'office_id')">
					<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i>
						{{ 'have-a-error-in-this-field' | translate | capitalize }}
					</label>
					</div>
				</div>
				<div class="form__group">
					<label>{{ 'state' | translate | capitalize}}</label>
					<select name="state" list="state"  v-model="user.state.id" @change="getCitys" :disabled="!this.toggleEdit">
					<option></option>
					<option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
					</select>
					<div class="has-error has-message" v-show="errorForm(errors, 'address_state_id')">
					<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i>
						{{ 'have-a-error-in-this-field' | translate | capitalize }}
					</label>
					</div>
				</div>
				<div class="form__group">
					<label>{{ 'city' | translate | capitalize }}</label>
					<select  name="city" v-model="user.city.id" :disabled="(!citys.city) ? true : false || !this.toggleEdit">
					<option></option>
					<option v-for="city in citys.city" :value="city.id" :key="city.id">{{city.name}}</option>
					</select>
					<div class="has-error has-message" v-show="errorForm(errors, 'address_city_id')">
						<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i> {{ 'have-a-error-in-this-field' | translate | capitalize }}</label>
					</div>
				</div>

				<label>{{ 'organizationPicture' | translate | capitalize }}</label>
				<div class="form__group" v-if="user.organization.picture">
					<img :src="user.organization.picture" :alt="user.organization.name">
				</div>
				<div class="form__group__uploader">
					<input
						type="text"
						:placeholder="fileName"
						:class="{ 'form__group__uploader--disabled-gray': this.toggleEdit }"
						:disabled="!this.toggleEdit">
					<label for="picture" class="form__group__uploader__label">
						<input
						id="picture"
						type="file"
						ref="fileupload"
						name="file"
						@change="handleFileUpload($event)"
						:disabled="!this.toggleEdit"
						accept="image/*">
						<!-- {{ 'select' | translate | capitalize }} -->
						<span id="file-selected"></span>
					</label>
					<div v-if="this.user.picture" @click="resetFile()" class="form__group__remove-attachment">
						<i class="fas fa-times"></i>
						{{ 'remove-file' | translate | titleCase }}
					</div>
				</div>
				<div class="form__group submit__content">
					<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'" :disabled="!this.toggleEdit">
						<template v-if="!submitLoading">
							{{ 'save' | translate | capitalize }}
						</template>
						<template v-else>
							{{ 'saving' | translate | capitalize }}
						</template>
					</button>
				</div>
				<div v-if="successMsg" class="form__group text-center">
					<div class="success">
						<i class="fas fa-check"></i>
						{{ 'save-with-success' | translate | capitalize }}
					</div>
				</div>
				<div v-if="errorMessage" class="form__group text-center">
					<div class="has-error">
						<i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}</label>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'user',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			formPerfil: {
				success: false,
			},
			alert: false,
			fileName: '',
			slowClass: '',
			toggleEdit: false,
			submitLoading: false,
			successMsg: false,
			errorMessage: '',
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		partys() {
			return this.$store.state.register.partys;
		},
		officer() {
			return this.$store.state.register.office;
		},
		states() {
			return this.$store.state.register.states.state;
		},
		citys() {
			return this.$store.state.register.citys;
		},
		errors() {
			return this.$store.state.error;
		},
		success() {
			return this.$store.state.status;
		},
	},
	created() {
		this.$store.dispatch('getParty');
		this.$store.dispatch('stateCountry');
	},
	methods: {
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
		getFormData(object) {
			const formData = new FormData();
			Object.keys(object).forEach(key => formData.append(key, object[key]));
			return formData;
		},
		resetFile() {
			this.$refs.fileupload.value = '';
			this.user.picture = null;
			this.imageData = '';
			this.type = '';
			this.attachment_type = '';
			this.fileName = '';
		},
		handleFileUpload(event) {
			const input = event.target;

			this.imageData = '';
			if (input.files && input.files[0]) {
				this.fileSize = event.target.files[0].size;

				if (event.target.files[0].size < 26214400) {
					this.type = 'attachment';
					[this.user.picture] = event.target.files;
					this.fileName = event.target.files[0].name;

					if ((/(image)/i).test(event.target.files[0].type)) {
						this.attachmentType = 'image';
					} else {
						this.errorMessage = 'Formato inválido';
					}
				} else {
					this.errorMessage = 'O arquivo excede o tamanho máximo permitido';
					setTimeout(() => {
						this.errorMessage = '';
					}, 4000);
				}
			}
		},
		errorForm(obj, field) {
			let error = '';
			if (obj[field]) {
				error = true;
			}
			return error;
		},
		toggleEditProfile() {
			this.toggleEdit = !(this.toggleEdit);
		},
		editProfile() {
			this.errorMessage = '';
			if (this.user.name || this.user.party.id || this.user.office.id ||
			this.user.state.id || this.user.city.id) {
				const payload = {};

				if (this.user.name) {
					payload.name = this.user.name;
				}

				if (this.user.party.id) {
					payload.party_id = this.user.party.id;
				}

				if (this.user.office.id) {
					payload.office_id = this.user.office.id;
				}

				if (this.user.state.id) {
					payload.address_state_id = this.user.state.id;
				}

				if (this.user.city.id) {
					payload.address_city_id = this.user.city.id;
				}
				if (this.user.picture) {
					payload.picture = this.user.picture;
				}
				this.toggleSubmitLoading();
				this.$store.dispatch('editUser', this.getFormData(payload))
					.then(() => {
						this.successMsg = this.success;
						setTimeout(() => {
							this.successMsg = false;
						}, 5000);
					})
					.then(() => this.$store.dispatch('loadUser', this.session))
					.then(() => this.toggleSubmitLoading())
					.catch(() => {
						this.errorMessage = this.errors.error;
						this.toggleSubmitLoading();
					});
			} else {
				this.errorMessage = 'Preencha um dos campos';
				setTimeout(() => {
					this.errorMessage = '';
				}, 5000);
			}
		},
		getOffice() {
			this.$store.dispatch('getOffice', this.user.gender);
		},
		getCitys() {
			this.$store.dispatch('citiesOfState', this.user.state.id);
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/profile/user.vue